import moment from 'moment';
import CryptoJS from 'crypto-js';
import { h5RouterList } from '@/config';
import { Dialog } from 'vant';

export const isObject = (o) => {
  return Object.prototype.toString.call(o) === '[object Object]';
};

export const serialize = (val) => {
  return JSON.stringify(val);
};

export const deserialize = (val) => {
  if (typeof val !== 'string') {
    return undefined;
  }
  try {
    return JSON.parse(val);
  } catch (e) {
    return val || undefined;
  }
};

export const setStorage = (key, val) => {
  localStorage.setItem(key, serialize(val));
};

export const getStorage = (key) => {
  return deserialize(localStorage.getItem(key));
};

export const batchSetStorage = (obj) => {
  for (const [key, value] of Object.entries(obj)) {
    localStorage.setItem(key, serialize(value));
  }
};

export const saveAccount = (username, password) => {
  let userList = getAccount();
  for (let i in userList) {
    if (userList[i].username == username) {
      userList.splice(i, 1);
      break;
    }
  }
  let user = {
    username: username,
    password: password,
  };
  if (!userList) userList = [];
  userList.unshift(user);
  if (userList.length > 5) {
    userList = userList.slice(0, 5);
  }
  let str = '';
  userList.forEach((val, index, _) => {
    str += val.username + ':' + val.password + '|';
  });
  let str2 = str.substring(0, str.length - 1);
  localStorage.setItem('userList', str2);
};

export const getAccount = () => {
  let userList = localStorage.getItem('userList');
  if (!userList) {
    return '';
  }
  let userArr = userList.split('|');
  userList = [];
  for (let i = 0; i < userArr.length; i++) {
    if (!userArr[i]) {
      continue;
    }
    let arr = userArr[i].split(':');
    let userObj = { username: arr[0], password: arr[1] };
    userList.push(userObj);
  }
  return userList;
};

export const saveAccountList = (arr) => {
  let str = '';
  arr.forEach((item) => {
    str = str ? `${str}|${item.username}:${item.password}` : `${item.username}:${item.password}`;
  });
  localStorage.setItem('userList', str);
};

export const saveCellAccount = (tel_num, credential) => {
  let cellList = getCellAccount();
  if (!cellList) {
    cellList = [{ tel_num, credential }]
  } else {
    const result = cellList.findIndex(item => item.tel_num == tel_num);
    if (result !== -1) {
      cellList.splice(result, 1);
      cellList.unshift({ tel_num, credential })
    } else {
      cellList.unshift({ tel_num, credential })
      if (cellList.length > 5) cellList.pop()
    }
  }
  setStorage('cellUserList', cellList);
};

export const getCellAccount = () => {
  let cellList = getStorage('cellUserList');
  return cellList || [];
};

export const delCellAccount = (tel_num) => {
  let cellList = getCellAccount();
  const result = cellList.findIndex(item => item.tel_num == tel_num);
  if (result !== -1) {
    cellList[result].credential = ''
  }

  setStorage('cellUserList', cellList);
}

export const geTel = (tel) => {
  const reg = /^(\d{3})\d{4}(\d{4})$/;
  return tel.replace(reg, '$1****$2');
};

// 剩余时间
export const diffDateline = (end) => {
  const start_date = moment();
  const end_date = moment(end);
  const days = end_date.diff(start_date, 'days');
  // 大于一天显示天
  if (days >= 1) return `${days}天`;
  // 大于一小时显示小时
  const hours = end_date.diff(start_date, 'hours');
  if (hours >= 1) return `${hours}小时`;
  // 大于一分钟显示分钟
  const minutes = end_date.diff(start_date, 'minutes');
  return `${minutes}分钟`;
};
/**
 * 版本号对比
 * @param {String} version_1 当前版本号
 * @param {String} version_2 需要比对版本号
 * @return {Boolean} 当前版本号是否大于等于需要比对的版本号
 */
export function versionCompare(version_1, version_2) {
  let v1 = version_1;
  let v2 = version_2;
  try {
    v1 = v1.split('.');
    v2 = v2.split('.');
    if (Number(v1[0]) > Number(v2[0])) {
      return true;
    } else {
      if (Number(v1[0]) === Number(v2[0])) {
        if (Number(v1[1]) > Number(v2[1])) {
          return true;
        } else if (Number(v1[1]) === Number(v2[1]) && Number(v1[2]) >= Number(v2[2])) {
          return true;
        }
      }
    }
    return false;
  } catch (error) {
    console.log(268, error);
    return false;
  }
}

//判断设备系统名称
export function isSysName() {
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) {
    return 'iphone';
  } else if (/android/.test(ua)) {
    return 'android';
  }
}

/**
根据身份证号码判断性别
15位身份证号码：第7、8位为出生年份(两位数)，第9、10位为出生月份，第11、12位代表出生日
18位身份证号码：第7、8、9、10位为出生年份(四位数)，第11、第12位为出生月份，
第13、14位代表出生日期，第17位代表性别，奇数为男，偶数为女。
*/
//根据身份证号获取年龄
export function GetAge(identityCard) {
  let len = (identityCard + '').length;
  let strBirthday = '';
  if (len == 18) {
    //处理18位的身份证号码从号码中得到生日和性别代码
    strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2);
  }
  if (len == 15) {
    let birthdayValue = '';
    birthdayValue = identityCard.charAt(6) + identityCard.charAt(7);
    if (parseInt(birthdayValue) < 10) {
      strBirthday = '20' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2);
    } else {
      strBirthday = '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2);
    }
  }
  //时间字符串里，必须是“/”
  let birthDate = new Date(strBirthday);
  let nowDateTime = new Date();
  let age = nowDateTime.getFullYear() - birthDate.getFullYear();
  //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  if (
    nowDateTime.getMonth() < birthDate.getMonth() ||
    (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
}

export function IdCodeValid(code) {
  //身份证号合法性验证
  //支持18位身份证号
  //支持地址编码、出生日期、校验位验证
  let city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外',
  };
  let row = {
    pass: true,
    msg: 0, //验证成功
  };
  if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(code)) {
    row = {
      pass: false,
      msg: 1, //身份证号格式错误
    };
  } else if (!city[code.substr(0, 2)]) {
    row = {
      pass: false,
      msg: 2, //身份证号地址编码错误
    };
  } else {
    //18位身份证需要验证最后一位校验位
    if (code.length == 18) {
      code = code.split('');
      //∑(ai×Wi)(mod 11)
      //加权因子
      let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      //校验位
      let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
      let sum = 0;
      let ai = 0;
      let wi = 0;
      for (let i = 0; i < 17; i++) {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
        // console.log(parity[sum % 11], "ai:", ai, "wi:", wi, " sum:", sum);
      }

      if (parity[sum % 11] != code[17].toUpperCase()) {
        row = {
          pass: false,
          msg: 3, //身份证号校验位错误
        };
      }
    }
  }
  return row;
}
// 生成参数签名
export const sort_ASCII = (obj) => {
  let arr = [];
  let num = 0;
  const secret = 'p5k8vpRk';
  for (let i in obj) {
    arr[num] = i;
    num++;
  }
  let sortArr = arr.sort();
  sortArr = sortArr.map((item) => {
    return `${item}=${encodeURIComponent(obj[item])}`;
  });
  let sortString = `${sortArr.join('&')}${secret}`;
  return {
    ...obj,
    sign: CryptoJS.MD5(sortString).toString().toLowerCase(),
  };
};

// 判断是原生还是h5包
export const isPure = () => {
  const { pathname } = window.location;
  let flag = true;
  h5RouterList.map((item) => {
    if (pathname.indexOf(item) !== -1) flag = false;
  });
  return flag;
};

export function isAndroid() {
  let u = navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
}

// 判断横竖屏 true 竖屏 false 横屏
export function y_portrait() {
  if (window.orientation == 180 || window.orientation == 0) {
    return true;
  } else {
    return false;
  }
}

export function y_ipad() {
  var ua = navigator.userAgent.toLowerCase();
  var s;
  s = ua.match(/iPad/i);

  if (s == 'ipad') {
    return true;
  } else {
    return false;
  }
}

/**
 * @name randomN
 * @description 获取一个n位的随机的数字和大小写字母随机组合，且中间四位数设置为*
 * @param {Number} n n位
 * @returns {String} n位的随机的数字和大小写字母随机组合，且中间四位数设置为*
 */
const numberSet = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
const strSet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
export function randomN(n) {
  let res = '';

  for (let i = 0; i < n; i++) {
    if ([2, 3, 4, 5].includes(i)) {
      res += '*';
    } else {
      res += add();
    }
  }

  function add() {
    // 生成一个随机数（1.数字 2.小写字母 3.大写字母）
    let r1 = Math.ceil(Math.random() * 3);
    if (r1 == 1) {
      // 数字，生成一个 0-9 的随机数
      let r2 = Math.floor(Math.random() * 10);
      return numberSet[r2];
    } else if (r1 == 2) {
      // 小写字母，生成一个 0-25 的随机数
      let r2 = Math.floor(Math.random() * 26);
      return strSet[r2];
    } else if (r1 == 3) {
      // 大写字母，生成一个 0-25 的随机数
      let r2 = Math.floor(Math.random() * 26);
      return strSet[r2].toUpperCase();
    }
  }

  return res;
}

export const isWeiXin = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) == 'micromessenger'
}

/***
 * 判断是否是ios自带浏览器
 */
export function isSafari() {

  var ua = navigator.userAgent.toLowerCase();

  if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
    ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
    ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1) {
    return true;
  } else {
    return false;
  }
}

export function isStandalone() {
  return navigator.standalone || (window.matchMedia('(display-mode: standalone)').matches);
}

export function deleteDivIfExists(divId) {

  var div = document.getElementById(divId);
  if (div) {
    div.remove(); // 或者使用 parentNode.removeChild(div);
  }

}

// 自定义弹窗
export function customDialog(obj) {
  let {title, message, confirmButtonText, cancelButtonText, comfirmCallback, cancelCallback} = obj;
  Dialog.confirm({
    title,
    message,
    confirmButtonText,
    cancelButtonText
  }).then(() => {
    // on confirm
    comfirmCallback()
  }).catch(() => {
    // on cancel
    cancelCallback()
  });
}